import { useEffect, useState } from 'react';

const useScreenBreakpoint = (breakpoint: number) => {
  const [isMobile, setIsMobile] = useState<boolean | undefined>(undefined);

  const checkIsMobile = () => {
    const mobile: boolean = window.innerWidth <= breakpoint;
    setIsMobile(mobile);
  };

  useEffect(() => {
    window.addEventListener('resize', checkIsMobile);
    checkIsMobile();

    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  return isMobile;
};

export default useScreenBreakpoint;
